import React from "react";
import "../../App.css";

export default function ECommittee() {
  return (
    <div className="e-committee">
      <h1>Executive Committee 2021</h1>
      <div className="ec-list">
        <ul className="general-managers">
          <h4> General Managers:</h4>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Baby Zepps:</strong>
            <ol> Dan G. & Helder B. </ol>{" "}
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""} <strong>Bad Dog:</strong>
            <ol> Laura S. & Chris B.</ol>
          </li>
          <br />
          <li>
            {" "}
            <i class="fas fa-baseball-ball" /> {""}
            <strong>The Beauties:</strong>
            <ol>Amber P. & Scott B. </ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Beavis and Buntheads:</strong>
            <ol> Freddie R. & Lexa G. </ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Comedy Bar:</strong>
            <ol>Gary R. & Jen F. </ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Hecklers:</strong>
            <ol>Micheal W. & Justin W.</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Jokebox:</strong>
            <ol>Deanna P.D. & James D.</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>The Orphans:</strong>
            <ol>Virginia W. & Dan R.</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Pring's Things:</strong>
            <ol>Darryl P. & Kyra W..</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}
            <strong>Slo Claps:</strong>
            <ol>Kyle S. & Karen H.</ol>
          </li>
        </ul>
        <ul>
          <h4>Elected Committee:</h4> <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""} <strong>Treasurer:</strong>{" "}
            <ol> Andrew H. </ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}{" "}
            <strong>Head ScoreKeeper: </strong>
            <ol>TBD</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}{" "}
            <strong>Social Committee: </strong>
            <ol>Arleigh C.</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}{" "}
            <strong>Equipment Head:</strong> <ol>TBD</ol>
          </li>
          <br />
          <li>
            <i class="fas fa-baseball-ball" /> {""}{" "}
            <strong>Media/Tech Team: </strong>
            <ol>Jim K., Allana M. & Amber P.</ol>
          </li>
        </ul>
      </div>
    </div>
  );
}
